import DataCenter from "../data/DataCenter";
import DictType from "../data/DictType";
import DataField from "./DataField";
import DB from "./DB";
import FieldRelation from "./FieldRelation";
import KeyType from "./KeyType";
import ModuleCenter from "./ModuleCenter";

const defaultFields = [
    {code:'id', key:true},
    {code:'tags', name:'标签', type:'tag'},
]

const addDefaultFields = (fields)=> {
    if (!fields || !fields.length) fields = [];
    const hasField = (fields, field)=> {
        for (const f of fields) {
            if (f.code == field.code) return true;
        }
        return false;
    }
    const fs = [];
    for (const df of defaultFields) {
        if (!hasField(fields, df)) fs.push(df);
    }
    return fields.concat(fs);
}

class DataModule {
    _code = null;
    _relationCode = null;
    _type = null;
    _fields = null;
    _keyField = null;
    _nameField = null;
    _queryFields = null;
    _fieldMap = {};
    _remoteOptions = {};
    _dataInfo = null;
    _relFields = [];
    _foreignMap = {};
    _foreignModules = {};
    _testTable = null;
    _relatedModules = {};
    _summaryFields = [];

    _merge = null;

    constructor(code, config, dict, iconMap) {
        this._iconMap = iconMap;
        this._config = config;
        this._code = code;
        this._relationCode = config.relationCode;
        this._bindEntity = config.bindEntity;
        if (!config.fields) {
            console.log(code, 'has no fields');
        }
        this._fields = (config.dictType == DictType.STATIC || config.apiVersion == 'v0') ? config.fields : addDefaultFields(config.fields);
        this._testSize = config.testSize || 30;
        // this._type = config.type || 'Dictionary';
        // this._keyField = config.keyField || null;
        this._nameField = config.nameField || null;
        this._queryFields = config.queryFields;
        this._listFields = config.listFields;
        this._formFields = config.formFields;
        this._remoteOptions = config.remoteOptions;
        let jsonFields = null;
        for (const fieldConfig of this._fields) {
            if (fieldConfig.jsonField) {
                if (!jsonFields) jsonFields = {};
                const jf = jsonFields[fieldConfig.jsonField] || (jsonFields[fieldConfig.jsonField] = []);
                jf.push(fieldConfig.code);
            }
            const dataField = new DataField(fieldConfig);
            if (fieldConfig.summary) this._summaryFields.push(fieldConfig.code);
            if (dataField.isPrimaryKey()) {
                if (!this._keyField) this._keyField = dataField.getCode();
                if (!config.keyField) config.keyField = [dataField.getCode()];
                else config.keyField.push(dataField.getCode());
                const foreignField = dataField.getForeignField();
                if (foreignField) {
                    if (!this._foreignMap[foreignField]) this._foreignMap[foreignField] = [dataField];
                    else this._foreignMap[foreignField].push(dataField);
                    const fields = this._foreignModules[dataField._relModuleCode];
                    if (!fields) this._foreignModules[dataField._relModuleCode] = [dataField];
                    else fields.push(dataField);
                }
            } else if (dataField.isForeignKey()) {
                this._relFields.push(dataField);
                const foreignField = dataField.getForeignField();
                if (!this._foreignMap[foreignField]) this._foreignMap[foreignField] = [dataField];
                else this._foreignMap[foreignField].push(dataField);
                const fields = this._foreignModules[dataField._relModuleCode];
                if (!fields) this._foreignModules[dataField._relModuleCode] = [dataField];
                else fields.push(dataField);
                // this._dataInfo.addIndexField(dataField.getCode());
                if (!config.indexFields) config.indexFields = [dataField.getCode()];
                else config.indexFields.push(dataField.getCode());
            }
            this._fieldMap[fieldConfig.code] = dataField;
        }
        let treeField = this._foreignModules[code];
        if (treeField && treeField.length) {
            treeField = treeField[0];
            const keyField = treeField._relFieldCode;
            config.treeInfo = {keyField:keyField, parentField:treeField.getCode()};
            if (this._fieldMap[keyField]) this._fieldMap[keyField]._tree = true;
        }
        if (this._bindEntity) {
            const bindField = this._fieldMap[this._bindEntity.idField || 'refEntityId'];
            bindField._keyType = KeyType.FK;
            if (!config.indexFields) config.indexFields = [bindField.getCode()];
            else config.indexFields.push(bindField.getCode());
            const relInfos = [];
            for (const rel of this._bindEntity.typeRels) {
                if (!/^(\w+)\.(\w+)(?:\:(\w+))?$/.test(rel)) return null;
                const moduleCode = RegExp.$1;
                const fieldCode = RegExp.$2;
                // const relField = RegExp.$3 || this._bindEntity.idField;
                // const relInfo = ModuleCenter.test(moduleCode, fieldCode);
                // if (!relInfo) {
                //     console.log('module field', moduleCode + '.' + fieldCode, 'is not defined.');
                //     return null;
                // }
                // if (relField) relInfo.relField = relField;
                // relInfo.rs = FieldRelation.FR_Mv1;
                // relInfos.push(relInfo);
                const foreignModules = this._foreignModules[moduleCode] || (this._foreignModules[moduleCode] = []);
                foreignModules.push(bindField);
                const foreignMap = this._foreignMap[moduleCode + '.' + fieldCode] || (this._foreignMap[moduleCode + '.' + fieldCode] = []);
                foreignMap.push(bindField);
                // this._foreignMap[moduleCode + '.' + fieldCode] = relInfo.field;
            }
            bindField.setDynamicRelatedInfo(relInfos);
        }
        config.jsonFields = jsonFields;
        this._dataInfo = DataCenter.createDictionary(code, config, dict);

        // this._merge = config.merge;
        // if (config.merge && dict && dict.length) {
        //     this.merge(dict, config.merge);
        // }

        // this._testTable = DB.createTable(code, this._fields, config.testSize || 200);
        window.setTimeout(()=> {
            for (const [code, value] of Object.entries(this._foreignModules)) {
                const module = ModuleCenter.getModule(code);
                if (module == null) {
                    console.log('module', code, 'is not exists.')
                }
                try {
                    module.registRelatedModule(this);
                } catch(e) {}
            }
            if (config.merge) {
                const mergeInfo = this.getMergeInfo(config.merge, config.mergeRelation);
                if (mergeInfo) this._dataInfo.setMergeInfo(mergeInfo);
            }
            if (config.dynamicMerge) {
                this._dataInfo.setDynamicMergeInfo(config.dynamicMerge)
            }
        }, 0)
    }
    resetBindInfos() {
        if (this._bindEntity) {
            const bindField = this._fieldMap[this._bindEntity.idField || 'refEntityId'];
            const relInfos = [];
            for (const rel of this._bindEntity.typeRels) {
                if (!/^(\w+)\.(\w+)(?:\:(\w+))?$/.test(rel)) return null;
                const moduleCode = RegExp.$1;
                const fieldCode = RegExp.$2;
                const relField = RegExp.$3 || this._bindEntity.idField;
                const relInfo = ModuleCenter.test(moduleCode, fieldCode);
                if (!relInfo) {
                    console.log('module field', moduleCode + '.' + fieldCode, 'is not defined.');
                    return null;
                }
                if (relField) relInfo.relField = relField;
                relInfo.rs = FieldRelation.FR_Mv1;
                relInfos.push(relInfo);
                // const foreignModules = this._foreignModules[moduleCode] || (this._foreignModules[moduleCode] = []);
                // foreignModules.push(bindField);
                // const foreignMap = this._foreignMap[moduleCode + '.' + fieldCode] || (this._foreignMap[moduleCode + '.' + fieldCode] = []);
                // foreignMap.push(bindField);
                // this._foreignMap[moduleCode + '.' + fieldCode] = relInfo.field;
            }
            bindField.setDynamicRelatedInfo(relInfos);
        }
    }
    getModuleRelation(code, checked) {
        const relModule = ModuleCenter.getModule(code);
        if (!relModule) return null;
        const fields = this._foreignModules[code];
        if (fields) {
            for (const field of fields) {
                if (field.isForeignKey() || field.isPrimaryKey()) return {relModule:relModule, srcField:field.getCode(), destField:field.getForeignFieldCode() || field.getDynamicForeignFieldCode(code)}
            }
        }
        if (checked) return null;
        const rel = relModule.getModuleRelation(this._code, true);
        if (rel) return {relModule:relModule, srcField:rel.destField, destField:rel.srcField};
        return null;
    }
    getMergeInfo(merges, relation) {
        if (!merges) return null;
        const mergeRelation = {};
        if (relation) {
            for (const [code, rel] of Object.entries(relation)) {
                mergeRelation[code] = {srcField:rel.src, destField:rel.dest, relModule:ModuleCenter.getModule(rel.module || code)}
            }
        }
        const mergeInfo = {};
        if (merges instanceof Array) {
            for (const merge of merges) {
                /^([\w]+)\.([\w]+)(?:\:([\w]+))?$/.test(merge);
                const code = RegExp.$1;
                const field = RegExp.$2;
                const mfield = RegExp.$3 || field;
                const mr = mergeRelation[code];
                const rel = mr ? mr : this.getModuleRelation(code);
                if (rel) {
                    let mi = mergeInfo[code];
                    if (!mi) mi = mergeInfo[code] = Object.assign({}, rel, {fields:{}});
                    mi.fields[mfield] = field;
                }
            }
        } else if (merges instanceof Object) {
            Object.assign(mergeInfo, merges);
        }
        return mergeInfo;
    }
    getGateway() {
        return this._config?.gateway;
    }
    isBindEntity() {
        return this._bindEntity || false;
    }
    getForeignMap() {
        return this._foreignMap;
    }
    getForeignModules() {
        const modules = [];
        for (const [code, fields] of Object.entries(this._foreignModules)) {
            modules.push(ModuleCenter.getModule(code));
        }
        return modules;
    }
    dynamicMerge(datas, parentData) {
        return this._dataInfo.dynamicMerge(datas, parentData);
    }

    registRelatedModule(module) {
        const code = module.getCode();
        if (!this._relatedModules[code]) this._relatedModules[code] = module;
    }

    createTestTable() {
        this._testTable = DB.createTable(this._code, this._fields, this._testSize);
    }

    hasField(field) {
        return this._fieldMap[field] !== undefined;
    }

    getModuleType() {
        return this._dataInfo.getDictType();
    }

    getCode() {
        return this._code;
    }
    getRelationCode() {
        return this._relationCode || this._code;
    }

    keyFields() {
        return this._dataInfo.keyFields();
    }

    getSummaryFields() {
        return this._summaryFields;
    }

    getDictType() {
        return this._dataInfo.getDictType();
    }
    getDataField(field) {
        if (field == 'options') return null;
        const dataField = this._fieldMap[field] || null;
        if (dataField) return dataField;
        // console.log('%cmodule field ' + this._code + '.' + field + ' is not exists.', 'color:#F00')
        return null;
    }
    getRelatedInfo(field) {
        const dataField = this.getDataField(field);
        if (!dataField) return null;
        return dataField.getRelatedInfo();
    }
    getRelFields() {
        return this._relFields;
    }
    getForeignField(rel) {
        const fields = this._foreignMap[rel];
        if (fields && fields.length) return fields[0];
        return null;
    }

    getMappedKeyData(data, relModule, field) {
        const keyData = {};
        // if (data && relModule) {
        //     const dataField = field ? this.getDataField(field) : this._foreignModules[relModule][0];
        //     keyData[dataField.getCode()] = data[dataField._relFieldCode];
        // }
        return keyData;
    }


    getDataOptions(datas, nameField, keyField) {
        return this._dataInfo.getDataOptions(datas, nameField, keyField);
    }

    defaultKeyField() {
        return this._dataInfo.defaultKeyField();
    }

    moduleKeyField() {
        const keyFields = this.keyFields();
        if (keyFields && keyFields.length) return keyFields[0]
        // for (const keyField of keyFields) {
        //     if (keyField != 'id') return keyField;
        // }
        return 'id';
    }

    dataKey(data, keyField) {
        return this._dataInfo.dataKey(data, keyField);
    }
    datasKeys(datas, keyField) {
        return this._dataInfo.datasKeys(datas, keyField);
    }

    filterKeyData(keyData) {
        if (!keyData) return null;
        const filteredData = {};
        for (const [key, value] of Object.entries(keyData)) {
            if (this.hasField(key)) filteredData[key] = value;
        }
    }
    async queryDatas(queryParams, keyData, pagination, extData) {
        // const filteredData = this.filterKeyData(keyData);
        return this._dataInfo.queryDatas(queryParams, keyData, pagination, extData);
    }
    async queryDatasMute(queryParams, keyData, pagination, extData) {
        return this._dataInfo.queryDatasSilence(queryParams, keyData, pagination, extData);   
    }
    async queryDatasWithUrl(url, queryParams, keyData, pagination, extData) {
        return this._dataInfo.queryDatasWithUrl(url, queryParams, keyData, pagination, extData);
    }
    getDataLocal(key, keyField) {
        return this._dataInfo.getDataLocal(key, keyField);
    }
    getDatasLocal(keys, keyField) {
        return this._dataInfo.getDatasLocal(keys, keyField);
    }
    async getAllDatas() {
        const datas = await this._dataInfo.getAllDatas();
        if (datas && datas.length) {
            return datas.sort((a, b)=> (a.orders || -1) - (b.orders || -1));
        }
    }
    async getData(key, keyField) {
        return this._dataInfo.getData(key, keyField);
    }
    async getDataWithUrl(url, key, keyField) {
        return this._dataInfo.getDataWithUrl(url, key, keyField);
    }
    getByKeysLocal(keys, keyField) {
        return this._dataInfo.getByKeysLocal(keys, keyField);
    }
    async getByKeys(keys, keyField) {
        return this._dataInfo.getByKeys(keys, keyField);
    }
    async getByIndices(indices, indexField) {
        return this._dataInfo.getByIndices(indices, indexField);
    }
    async getByKey(key, keyField) {
        const datas = await this.getByKeys([key], keyField);
        if (datas && datas.length) return datas[0];
        return null;
    }
    getByFKeysLocal(fKeys, field) {
        return this._dataInfo.getByIndicesLocal(fKeys, field);
    }
    async getByFKeys(fKeys, field) {
        return this._dataInfo.getByIndices(fKeys, field);
    }
    async createData(data) {
        return this._dataInfo.createData(data);
    }
    async createDatas(datas) {
        return this._dataInfo.createDatas(datas);
    }
    async editData(key, data, conf) {
        return this._dataInfo.editData(key, data, conf)
    }
    async editDatas(datas) {
        return this._dataInfo.editDatas(datas);
    }
    async createDataWithUrl(url, data) {
        return this._dataInfo.createDataWithUrl(url, data);
    }
    async editDataWithUrl(url, key, data) {
        return this._dataInfo.editDataWithUrl(url, key, data);
    }
    async deleteDatasByKeys(keys) {
        return this._dataInfo.deleteDatasByKeys(keys);
    }
    async getNextData(data, filter) {
        return this._dataInfo.getNextData(data, filter);
    }

    async simpleCall(url, data, type) {
        return this._dataInfo.simpleCall(url, data, type);
    }

    async getKey(key) {
        return this._dataInfo.getKey(key);
    }
    matchLocal(condition) {
        return this._dataInfo.match(condition)
    }
}

export default DataModule